export const EOL = {};
export const EOF = {};
export const QUOTE = 34;
export const NEWLINE = 10;
export const RETURN = 13;